/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.15
 */
let { CircleMarker, Path } = L;
import load from "@/utils/Loader";
/**
 * 
 */
export default CircleMarker.extend({
  /**
   * 
   */
  options: {
    glow: false, //闪烁,常用于水雨情预警
    weight: 0.5,
    color: '#000',
    stroke: true,
    radius: 5,   // 圆的半径，等腰三角形的底边长
    angle: 0     // Math.random() * 2 * Math.PI 三角形角度
  },
  /**
   * @override
   */
  _project: function () {
    this._point = this._map.latLngToLayerPoint(this._latlng);
    let { offset } = this.options;
    if (offset) {
      this._point = this._point.add(offset);
    }
    this._updateBounds();
  },
  /**
   * @override
   */
  beforeAdd: function (map) {
    let { options } = this;
    // 确保 renderer is canvas,且canvas是唯一的。否则图层相互覆盖影响;
    if (!map.options.preferCanvas && !options.renderer) {
      options.renderer = map.__canvas = map.__canvas || L.canvas();
    }
    CircleMarker.prototype.beforeAdd.call(this, map)
  },
  /**
   * @override
   * todo 优化性能，预执行
   */
  _updatePath: function () {
    let that = this;
    let { options, _renderer } = that;
    let { src } = options;
    src = src || 'circle';
    switch (src) {
      case 'triangle':
        return _renderer._updateTriangle(that);
      case 'rect':
        return _renderer._updateRect(that);
      case 'circle':
        return _renderer._updateCircle(that);
      default:
        if (that._loader) {
          _renderer._updateIcon(that);
        } else {
          // todo
          if (src && src.indexOf('/') !== 0 && !src.includes('http')) {
            src = options.src = T + src;
          }
          !that.loader && (that.loader = load(src)).then(img => {
            that._loader = img;
            that._radius = img.width / 2;
            that._radiusY = img.height / 2;
            that.redraw();
          })
        }
        break;
    }
  }
})
/**
 * 
 */
Path.include({
  onAdd() {
    let { options, _map, _renderer } = this;
    if (options.glow || options.flow || options.bounce || options.rotate) {
      let { __glow, __animate } = _map;
      if (options.glow || options.flow) {
        __glow._initPath(this);
      }
      if (options.bounce || options.rotate) {
        __animate._initPath(this);
      }
    }
    _renderer._initPath(this);
    this._reset();
    _renderer._addPath(this);
  },
  onRemove() {
    let { _map, _renderer } = this;
    _renderer._removePath(this);
    _map.__glow._removePath(this);
    _map.__animate._removePath(this);
  }
});



// WEBPACK FOOTER //
// ./src/marker/PathMarker.js